import axios, { getEnv } from './api';

// FILTERS
function filterRoutes(fill) {
  let url = '';
  // DATA INICIAL
  if (fill?.dataFinal && !fill?.dataInicial) {
    url = `?dataFim=${fill?.dataFinal}`;
    return url;
  }
  // DATA FINAL E INICIAL
  else if (
    fill?.dataFinal &&
    fill?.dataInicial &&
    !fill?.cidades &&
    !fill?.ufs
  ) {
    url = `?dataInicio=${fill?.dataInicial}&dataFim=${fill?.dataFinal}`;
    return url;
  }
  // TODOS
  else if (fill?.dataFinal && fill?.dataInicial && fill?.ufs && fill?.cidades) {
    url = `?cidade=${fill?.cidades?.map((c) => c.id)}&dataFim=${fill?.dataFinal
      }&dataInicio=${fill?.dataInicial}&uf=${fill?.ufs?.map((uf) => uf.id)}`;
    return url;
  }
  // DATA FINAL/INICIAL E UF
  else if (fill?.dataFinal && fill?.dataInicial && fill?.ufs) {
    url = `?dataFim=${fill?.dataFinal}&dataInicio=${fill?.dataInicial
      }&uf=${fill?.ufs?.map((uf) => uf.id)}`;
    return url;
  }

  // UF E CIDADE
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    fill?.ufs &&
    fill?.cidades
  ) {
    url = `?cidade=${fill?.cidades?.map((c) => c.id)}&uf=${fill?.ufs?.map(
      (uf) => uf.id
    )}`;
    return url;
  }
  // CIDADE
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    !fill?.ufs &&
    fill?.cidades
  ) {
    url = `?cidade=${fill?.cidades?.map((c) => c.id)}`;
    return url;
  }
  // UF
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    !fill?.cidades &&
    fill?.ufs
  ) {
    url = `?uf=${fill?.ufs?.map((uf) => uf.id)}`;
    return url;
  }
  return url;
}


const dashboardServiceUser = {
  getUsuariosAtivos: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/usuarios-ativos${filterRoutes(filters)}&tipoPessoa=TODAS`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getUsuariosAtivosPf: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/usuarios-ativos${filterRoutes(filters)}&tipoPessoa=PESSOA_FISICA`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getUsuariosAtivosPj: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/usuarios-ativos${filterRoutes(filters)}&tipoPessoa=PESSOA_JURIDICA`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getUf: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/uf${filterRoutes(filters)}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getTotal: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/total${filterRoutes(filters)}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPf: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/tipo-pessoa${filterRoutes(filters)}&tipoPessoa=PESSOA_FISICA`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPj: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/tipo-pessoa${filterRoutes(filters)}&tipoPessoa=PESSOA_JURIDICA`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPjMei: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/porte${filterRoutes(filters)}&porte=MEI`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPjMe: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/porte${filterRoutes(filters)}&porte=ME`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPjEpp: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/porte${filterRoutes(filters)}&porte=EPP`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPjOutros: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/porte${filterRoutes(filters)}&porte=OUTROS`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getNovos: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/usuario/dashboard/novos${filterRoutes(filters)}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },

};

export default dashboardServiceUser;
